import { TwcaAtlAgentLib } from './atl-agent';
import { TwcaFormWindowLib } from './form-window';

export class TwcaVerifyLib {
  twcaAtlAgentLib = new TwcaAtlAgentLib();
  twcaFormWindowLib = new TwcaFormWindowLib();

  constructor() {

  }

  // 使用中介代替元件後，以原功能介面呼叫中介
  IDPaaSCpntCheck = this.legacyCpntCheck;
  IDPaaSCpntServerAuth = this.legacyCpntServerAuth;
  IDPaaSMoicaSign = this.legacyMoicaSignPkcs7;
  IDPaaSMoicaSignPKCS1 = this.legacyMoicaSignPkcs1;
  IDPaaSXmlSignPKCS1 = this.legacyXmlSignPkcs1;
  IDPaaSAtmTac = this.legacyAtmTac;
  IDPaaSCapiAgentCheck = (cbf) => this.twcaAtlAgentLib.capiCheck(cbf);
  IDPaaSCapiAgentServerAuth = (serverAuthCode, cbf) => this.twcaAtlAgentLib.capiServerAuth(serverAuthCode, cbf);
  IDPaaSCapiSignPKCS7 = (certFilter, pwd, cts, cbf) => this.twcaAtlAgentLib.capiSignPkcs7(certFilter, pwd, cts, cbf);

  // 保留
  idPaaSCpntCheck = this.IDPaaSCpntCheck;
  idPaaSCpntServerAuth = this.IDPaaSCpntServerAuth;
  idPaaSMoicaSign = this.IDPaaSMoicaSign;
  idPaaSMoicaSignPKCS7 = this.IDPaaSMoicaSign;
  idPaaSMoicaSignPKCS1 = this.IDPaaSMoicaSignPKCS1;
  idPaaSAtmTac = this.IDPaaSAtmTac;

  // 似乎未曾出現在文件上，但予以保留
  isMacOS = () => navigator.platform.indexOf('Mac') > -1;
  idPaaSMoeaSign = this.idPaaSMoicaSign;
  IDPaaSMoeaSign = this.idPaaSMoicaSign;
  idPaaSMoeaSignPKCS7 = this.idPaaSMoicaSign;
  IDPaaSMoeaSignPKCS7 = this.idPaaSMoicaSign;
  idPaaSMoeaSignPKCS1 = this.idPaaSMoicaSignPKCS1;
  IDPaaSMoeaSignPKCS1 = this.idPaaSMoicaSignPKCS1;

  legacyCpntCheck(type, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186000':
          code = '118a001';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    if (type == '6') {
      this.twcaAtlAgentLib.atmCheck(transCbf);
    } else {
      this.twcaAtlAgentLib.pk11Check(transCbf);
    }
  }

  legacyCpntServerAuth(type, serverAuthCode, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186001':
          code = '118a005';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    if (type == '6') {
      this.twcaAtlAgentLib.atmServerAuth(serverAuthCode, transCbf);
    } else {
      this.twcaAtlAgentLib.pk11ServerAuth(serverAuthCode, transCbf);
    }
  }

  legacyMoicaSignPkcs1(pwd, hash, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186100':
        case '1186101':
        case '1186102':
          code = '118c001';
          break;
        case '1186103':
        case '1186104':
          code = '118d001';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    this.twcaAtlAgentLib.pk11SignPkcs1Hashed(pwd, hash, transCbf);
  }

  legacyMoicaSignPkcs7(pwd, cts, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186100':
        case '1186101':
        case '1186102':
        case '1186103':
        case '1186104':
          code = '118d001';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    this.twcaAtlAgentLib.pk11SignPkcs7(pwd, cts, transCbf);
  }

  legacyXmlSignPkcs1(pwd, hash, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186100':
        case '1186101':
        case '1186102':
          code = '118c001';
          break;
        case '1186103':
        case '1186104':
          code = '118d001';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    this.twcaAtlAgentLib.pk11SignPkcs1Hashed(pwd, hash, transCbf);
  }

  legacyXmlSignPkcs7(pwd, cts, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186100':
        case '1186101':
        case '1186102':
        case '1186103':
        case '1186104':
          code = '118d001';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    this.twcaAtlAgentLib.pk11SignPkcs7(pwd, cts, transCbf);
  }

  legacyAtmTac(pwd, memberNo, tacDateStr, un, cbf) {
    let transCbf = (code, msg, reserved, data) => {
      switch (code) {
        case '1186110':
          code = '118d001';
          break;
        case '1186111':
          code = '118d002';
          break;
        case '1186112':
          code = '118d003';
          break;
        case '1186102':
          code = '118d007';
          break;
        case '1186105':
          code = '118d008';
          break;
      }
      cbf(code, msg, reserved, data);
    };

    this.twcaAtlAgentLib.atmTac(pwd, memberNo, tacDateStr, un, transCbf);
  }

  // Just for test
  IDPaaSPostAlsUrl = this.postAlsUrl;

  /**
   * 創建網銀視窗
   *
   * @param url        取得網銀 URL
   * @param eddarbank  取得網銀參數
   * @param rbanktoken 取得網銀參數 Token
   */
  postAlsUrl(url, eddarbank, rbanktoken) {
    this.twcaFormWindowLib.openAlsVerifyWindow(url, eddarbank, rbanktoken);
  }
}
